export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00251.3ae2f88c.png";